var cov_1d2hp955bq = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tooltip/styles/index.ts",
      hash = "759f31b924e783d13aae9b00c0d24b4afbf6f199",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tooltip/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 28
        },
        end: {
          line: 5,
          column: 62
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var tooltipLess = {};
import genaration from '../../utils/classname';
export var tooltipClass = (cov_1d2hp955bq.s[0]++, genaration(tooltipLess, 'tooltip'));